<template>
    <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row">
  <div class="col"><h5 class="text-capitalize">{{category}}</h5></div>
  <div class="col text-right"></div>
</div>

<b-card no-body>
      <b-tabs v-model="tabIndex" card>
        <b-tab title="New" title-link-class="darklink">
          <b-card-text><message-list :status="0" :user="user" :category="category" :event="event"></message-list></b-card-text>
        </b-tab>
        <b-tab title="Old" title-link-class="darklink">
          <b-card-text><message-list :status="1" :user="user" :category="category" :event="event"></message-list></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

      </div>
    </div>
  </div>
</template>  

<script>
export default {
  props: ["user"],

  data() {
    return {
      tabIndex: 0,
      category: 'notifications',
      event: 'NewNotification',
    };
  },

  mounted() {
    
  },

  created() {
    
  },

  methods: {

  },

};
</script>

<style scoped>

</style>